export default function ValidateRegPin(values: any) {
    let errors:any = {};
    
    if (!values.pin) {
        errors.pin = 'Az "Pin kód" mező kötelező!';
    }

    return errors;
}